import { render, staticRenderFns } from "./GoogleBusinessChannelDetail.vue?vue&type=template&id=15de870e&scoped=true"
import script from "./GoogleBusinessChannelDetail.vue?vue&type=script&lang=js"
export * from "./GoogleBusinessChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./GoogleBusinessChannelDetail.vue?vue&type=style&index=0&id=15de870e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15de870e",
  null
  
)

export default component.exports